import React from 'react';

export default function PlusIcon({width = '24px', height = '24px', color = 'inherit'}) {
  return (
    <svg style={{width, height, color}} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 1C12.7924 1 13.4348 1.64237 13.4348 2.43478V10.5652H21.5652C22.3576 10.5652 23 11.2076 23 12C23 12.7924 22.3576 13.4348 21.5652 13.4348H13.4348V21.5652C13.4348 22.3576 12.7924 23 12 23C11.2076 23 10.5652 22.3576 10.5652 21.5652V13.4348H2.43478C1.64237 13.4348 1 12.7924 1 12C1 11.2076 1.64237 10.5652 2.43478 10.5652H10.5652V2.43478C10.5652 1.64237 11.2076 1 12 1Z" fill="currentColor"/>
    </svg>    
  );
}